const a = (t, e) => ({
  ...t ? {
    "data-test-id": `${e}`
  } : {}
});
export {
  a as getDataTestAttributes
};
